/**
 * file : EmailRefuse.jsx
 * 설명 : 이메일무단수집거부 화면
 */

export default function EmailRefuse() {
  return (
    <div className="privacy" style={{ minHeight: '729px' }}>
        <div className="text-center mb-12" style={{ paddingTop: "170px" }}>
            <h1 className="common-title--h1">이메일무단수집거부</h1>
        </div>
        <div className="text-gray-5" style={{ padding: "35px" }}>
            정보통신망법 제50조에 의거하여 본 홈페이지에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적인 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망법에 의해 형사 처분됨을 유념하시기 바랍니다.           
        </div>
    </div>
  )
}